import { Row } from 'react-table';
import { getShortDate } from '../../../Utils/UtilFunctions';
import { Change } from '../Change';
import { GOLD_DATA, GRAM_WISE_SINGLE_CARAT_DATA } from '../types';
import { checkNumberSign } from '../utils';
import { addCommasToNumber } from '../../../Utils/CommonUtils';

const TableHeader = ({ text }: { text: string }): JSX.Element => {
  return <span className="text-base text-font-500 font-bold">{text}</span>;
};

interface COLUMN_TYPE {
  Header: string | JSX.Element;
  accessor: string;
  Cell: ({ row }: { row: Row<GOLD_DATA> }) => JSX.Element;
}

export interface SINGLE_CARAT_COLUMN_TYPE {
  Header: string | JSX.Element;
  accessor: string;
  Cell: ({ row }: { row: Row<GRAM_WISE_SINGLE_CARAT_DATA> }) => JSX.Element;
}

export const LAST_10_DAYS_GOLD_RATE_COLUMN = (gram = 1): COLUMN_TYPE[] => {
  return [
    {
      Header: <TableHeader text="Date" />,
      accessor: 'date',
      Cell: ({ row }) => {
        return (
          <span className="text-s-14 font-semibold capitalize">
            {getShortDate(row.original.date)}
          </span>
        );
      },
    },
    {
      Header: <TableHeader text="22 Carat" />,
      accessor: 'carat22',
      Cell: ({ row }) => {
        const carat22 = row.original.carat22;
        return (
          <div className="flex gap-2 items-center text-s-14">
            <span>₹{addCommasToNumber(carat22.ratePerGram * gram)}</span>
            <Change
              sign={checkNumberSign(carat22.change)}
              change={carat22.change * gram}
              showInBrackets={true}
              isSmall={true}
            />
          </div>
        );
      },
    },
    {
      Header: <TableHeader text="24 Carat" />,
      accessor: 'carat24',
      Cell: ({ row }) => {
        const carat24 = row.original.carat24;
        return (
          <div className="flex gap-2 items-center text-s-14">
            <span>₹{addCommasToNumber(carat24.ratePerGram * gram)}</span>
            <Change
              sign={checkNumberSign(carat24.change)}
              change={carat24.change * gram}
              showInBrackets={true}
              isSmall={true}
            />
          </div>
        );
      },
    },
  ];
};

export const GRAM_WISE_SINGLE_CARAT_COLUMN = [
  {
    Header: <TableHeader text="Weight" />,
    accessor: 'weight',
    Cell: ({ row }: { row: Row<GRAM_WISE_SINGLE_CARAT_DATA> }) => {
      return (
        <span className="text-s-14 sm:text-s-12 font-semibold whitespace-nowrap">
          {row.original.weight}
        </span>
      );
    },
  },
  {
    Header: <TableHeader text="Rate" />,
    accessor: 'rate',
    Cell: ({ row }: { row: Row<GRAM_WISE_SINGLE_CARAT_DATA> }) => {
      return (
        <div className="flex gap-2 items-center">
          <span className="text-s-14 sm:text-s-12">
            ₹{addCommasToNumber(row.original.rate)}
          </span>
        </div>
      );
    },
  },
  {
    Header: <TableHeader text="Change" />,
    accessor: 'change',
    Cell: ({ row }: { row: Row<GRAM_WISE_SINGLE_CARAT_DATA> }) => {
      return (
        <div className="flex gap-2 items-center text-s-14 sm:text-s-12">
          <Change
            sign={checkNumberSign(row.original.change)}
            change={row.original.change}
            showInBrackets={false}
            isSmall={true}
            hideOnMobile={false}
          />
        </div>
      );
    },
  },
] as SINGLE_CARAT_COLUMN_TYPE[];
